import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Alert, Button, Tabs, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useImpersonationService } from '../../services/impersonationService';
import { routesPath } from '../../common/constants/routesPath';
import ImpersonationUsersTable from './ImpersonationUsersTable';
import ImpersonationSessionsTable from './ImpersonationSessionsTable';

const ENDED_REASONS = ['stopped', 'expired', 'ended'];

/** Super Admin Users page (#790): find a dealer or consumer and open a read-only view as them. */
export default function Impersonation() {
    const { t } = useTranslation('impersonation');
    const { getConfig } = useImpersonationService();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [config, setConfig] = useState(null);
    const ended = searchParams.get('ended');

    useEffect(() => {
        getConfig()
            .then(setConfig)
            .catch(() => setConfig({ enabled: false }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div style={{ padding: 24 }}>
            <Typography.Title level={3}>{t('title')}</Typography.Title>
            {ENDED_REASONS.includes(ended) && (
                <Alert type="info" showIcon closable style={{ marginBottom: 16 }} message={t(`endedBanner.${ended}`)} />
            )}
            {config && !config.enabled ? (
                <Alert type="warning" showIcon message={t('disabled')} />
            ) : config?.actorEligible === false ? (
                // the feature is on, but only a Super Admin with 2FA on may impersonate
                <Alert
                    type="warning"
                    showIcon
                    message={t('needsTwoFactor')}
                    action={
                        <Button size="small" onClick={() => navigate(routesPath.ROOT.USER_SETTINGS)}>
                            {t('openSettings')}
                        </Button>
                    }
                />
            ) : (
                <Tabs
                    destroyInactiveTabPane
                    items={[
                        {
                            key: 'dealer',
                            label: t('tabs.dealer'),
                            children: <ImpersonationUsersTable realm="dealer" />,
                        },
                        {
                            key: 'consumer',
                            label: t('tabs.consumer'),
                            children: <ImpersonationUsersTable realm="consumer" />,
                        },
                        { key: 'sessions', label: t('tabs.sessions'), children: <ImpersonationSessionsTable /> },
                    ]}
                />
            )}
        </div>
    );
}
